"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    Avatar: {
      verticalAlign: 'middle',
      textAlign: 'center',
      alignItems: 'center',
      display: 'inline-flex',
      justifyContent: 'center',
      position: 'relative',
      width: function width(_ref) {
        var props = _ref.props;
        return props.size.width;
      },
      height: function height(_ref2) {
        var props = _ref2.props;
        return props.size.height;
      }
    },
    Initials: {
      width: function width(_ref3) {
        var props = _ref3.props;
        return props.size.width;
      },
      height: function height(_ref4) {
        var props = _ref4.props;
        return props.size.height;
      },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: function backgroundColor(_ref5) {
        var props = _ref5.props;
        return props.backgroundColor;
      },
      fontFamily: theme['$font-default'],
      fontWeight: 500,
      fontSize: 25
    },
    Round: {
      borderRadius: '100%',
      overflow: 'hidden',
      '& img': {
        borderRadius: '100%'
      }
    },
    Text: {
      textAlign: 'center',
      textTransform: 'uppercase',
      color: 'white'
    },
    Image: {
      position: 'absolute',
      width: function width(_ref6) {
        var props = _ref6.props;
        return props.size.width;
      },
      height: function height(_ref7) {
        var props = _ref7.props;
        return props.size.width;
      },
      objectFit: 'cover'
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map